<template>
    <div
        class="VSelect"
        v-click-outside="hideDropdown"
    >
        <div
            class="VSelect-title"
            @click="changeDropdownVisabillity(!isShowDropdown)"
        >
            <slot>
                <template v-if="item">
                    {{ item }}
                </template>
                <template v-else>
                    {{ noSelectedText }}
                </template>
            </slot>
        </div>
        <div
            class="VSelect-dropdown"
            v-if="isShowDropdown && isShowMenu"
        >
            <ul
            >
                <li
                    v-for="(option,optionIndex) in options"
                    class="VSelect-dropdown__li"
                    :class="{'VSelect-dropdown__li_active':(option === item) ||optionIndex === activeIndex }"
                    :key="optionIndex"
                    @click="chooseItem(option)"
                >
                    
                    {{ option }}
                </li>
                <li class="VSelect-dropdown__li_dropdown">
                    <slot name="dropdown-bottom"></slot>
                </li>
            </ul>
            <div class="VSelect-dropdown__input">
                <VInput
                    v-model="comboboxValue"
                    type="text"
                >
                </VInput>
                <VButton
                    :type="'button'"
                    theme="positive"
                    @click="chooseItem(comboboxValue)"
                >
                    Add
                </VButton>
            </div>
        </div>
    </div>
</template>

<script>
    import {fixBlockIntersection} from '../helpers/coordinatesHelper';
    
    export default {
        name: 'VSelect',
        model: {
            prop: 'item',
            event: 'updateItem',
        },
        props: {
            title: {
                type: String,
                default: '',
            },
            activeIndex: {
                type: Number,
                default: -1,
            },
            options: {
                type: Array,
                required: true,
                default: () => [],
            },
            item: {
                required: true,
                validator: prop => typeof prop === 'string' || prop == null,
            },
            noSelectedText: {
                type: String,
                default: 'No Selected',
            },
            isShowMenu: {
                type: Boolean,
                default: true,
            },
            isFixIntersection: {
                type: Boolean,
                default: true,
            },
            isCombobox: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                isShowDropdown: false,
                comboboxValue: '',
            };
        },
        methods: {
            changeDropdownVisabillity(isShow) {
                this.isShowDropdown = isShow;
                if (isShow) {
                    this.$emit('clickedButton');
                    if (this.isFixIntersection) {
                        this.$nextTick(() => {
                            fixBlockIntersection(this.$el.querySelector('.VSelect-dropdown'), {bottom: 50});
                        });
                    }
                }
                this.$emit('showDropDown', isShow);
            },
            chooseItem(item) {
                this.changeDropdownVisabillity(false);
                this.$emit('updateItem', item);
            },
            hideDropdown() {
                if (this.isShowDropdown) {
                    this.isShowDropdown = false;
                    this.comboboxValue = '';
                    this.$emit('closed');
                }
            },
        },
    };

</script>

<style
    scoped
    lang="scss"
>
    .VSelect {
        position: relative;
        
        &-title {
            display: flex;
            background: #FFFFFF;
            border-radius: 10px;
        }
        
        &-dropdown {
            position: absolute;
            max-height: 350px;
            z-index: $dropdown-z-index;
            background: #FFFFFF;
            overflow: auto;
            border-radius: 5px;
            //border-bottom: 10px solid #FFFFFF;
            width: 100%;
            min-width: 160px;
            @include scrollbar-styles;
            @include default-shadow;
            
            &__input {
                display: flex;
                margin: 10px;
                border-top: 1px solid $dark-blue-color;
                padding-top: 10px;
                
                ::v-deep {
                    input {
                        width: 140px !important;
                        height: 31px;
                        margin-right: 10px;
                    }
                }
            }
            
            &__li {
                list-style-type: none;
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 6px 15px;
                
                &:hover {
                    background: $primary-color;
                    color: #FFFFFF !important;
                }
                
                &_active {
                    background: $secondary-color;
                    color: #FFFFFF;
                }
                
                &_dropdown {
                    padding: 6px 15px;
                    list-style-type: none;
                    display: flex;
                    align-items: center;
                }
            }
            
        }
    }

</style>
